import { infoBarAddHandler, infoBarRemoveHandler } from './infoBarHandlers';
import { ComposeViewState } from 'owa-mail-compose-store';
import { AttachmentState, lazyDeleteAttachmentsViaQueueManager } from 'owa-attachment-well-data';
import { InlineAttachmentStatus } from 'owa-attachment-well-data';
import { ClientItemId } from 'owa-client-ids';
import { getCurrentTableMailboxInfo } from 'owa-mail-mailboxinfo';

export default function deletePendingInlineAttachment(
    placeholderId: string,
    composeViewState: ComposeViewState
) {
    if (!composeViewState.attachmentWell || !composeViewState.attachmentWell.inlineAttachments) {
        return;
    }

    // Find an inlineAttachment with the matching placeholderId that is currently pending
    let attachmentViewState: AttachmentState = null;
    for (let i = 0; i < composeViewState.attachmentWell.inlineAttachments.length; ++i) {
        const inlineAttachment = composeViewState.attachmentWell.inlineAttachments[i];
        if (
            inlineAttachment.placeholderId == placeholderId &&
            inlineAttachment.status === InlineAttachmentStatus.Initialized
        ) {
            attachmentViewState = inlineAttachment;
            break;
        }
    }

    // If a matching pending inline attachment was found, use the attachments queue manager to delete it
    if (attachmentViewState) {
        const parentItemId: ClientItemId = {
            ...composeViewState.itemId,
            mailboxInfo: getCurrentTableMailboxInfo(),
        };
        lazyDeleteAttachmentsViaQueueManager.importAndExecute(
            composeViewState.attachmentWell,
            attachmentViewState,
            parentItemId,
            infoBarAddHandler(composeViewState),
            infoBarRemoveHandler(composeViewState)
        );
    }
}
